/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as CRouteImport } from './routes/c'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CIndexRouteImport } from './routes/c/index'
import { Route as CWishlistRouteImport } from './routes/c/wishlist'
import { Route as CShopRouteImport } from './routes/c/shop'
import { Route as CPrivacyPolicyRouteImport } from './routes/c/privacy-policy'
import { Route as COrdertrackingRouteImport } from './routes/c/ordertracking'
import { Route as COrderplacedRouteImport } from './routes/c/orderplaced'
import { Route as CCheckoutRouteImport } from './routes/c/checkout'
import { Route as CProductItemIdRouteImport } from './routes/c/product.$itemId'

const CRoute = CRouteImport.update({
  id: '/c',
  path: '/c',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CIndexRoute = CIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CRoute,
} as any)
const CWishlistRoute = CWishlistRouteImport.update({
  id: '/wishlist',
  path: '/wishlist',
  getParentRoute: () => CRoute,
} as any)
const CShopRoute = CShopRouteImport.update({
  id: '/shop',
  path: '/shop',
  getParentRoute: () => CRoute,
} as any)
const CPrivacyPolicyRoute = CPrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => CRoute,
} as any)
const COrdertrackingRoute = COrdertrackingRouteImport.update({
  id: '/ordertracking',
  path: '/ordertracking',
  getParentRoute: () => CRoute,
} as any)
const COrderplacedRoute = COrderplacedRouteImport.update({
  id: '/orderplaced',
  path: '/orderplaced',
  getParentRoute: () => CRoute,
} as any)
const CCheckoutRoute = CCheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => CRoute,
} as any)
const CProductItemIdRoute = CProductItemIdRouteImport.update({
  id: '/product/$itemId',
  path: '/product/$itemId',
  getParentRoute: () => CRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/c': typeof CRouteWithChildren
  '/c/checkout': typeof CCheckoutRoute
  '/c/orderplaced': typeof COrderplacedRoute
  '/c/ordertracking': typeof COrdertrackingRoute
  '/c/privacy-policy': typeof CPrivacyPolicyRoute
  '/c/shop': typeof CShopRoute
  '/c/wishlist': typeof CWishlistRoute
  '/c/': typeof CIndexRoute
  '/c/product/$itemId': typeof CProductItemIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/c/checkout': typeof CCheckoutRoute
  '/c/orderplaced': typeof COrderplacedRoute
  '/c/ordertracking': typeof COrdertrackingRoute
  '/c/privacy-policy': typeof CPrivacyPolicyRoute
  '/c/shop': typeof CShopRoute
  '/c/wishlist': typeof CWishlistRoute
  '/c': typeof CIndexRoute
  '/c/product/$itemId': typeof CProductItemIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/c': typeof CRouteWithChildren
  '/c/checkout': typeof CCheckoutRoute
  '/c/orderplaced': typeof COrderplacedRoute
  '/c/ordertracking': typeof COrdertrackingRoute
  '/c/privacy-policy': typeof CPrivacyPolicyRoute
  '/c/shop': typeof CShopRoute
  '/c/wishlist': typeof CWishlistRoute
  '/c/': typeof CIndexRoute
  '/c/product/$itemId': typeof CProductItemIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/c'
    | '/c/checkout'
    | '/c/orderplaced'
    | '/c/ordertracking'
    | '/c/privacy-policy'
    | '/c/shop'
    | '/c/wishlist'
    | '/c/'
    | '/c/product/$itemId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/c/checkout'
    | '/c/orderplaced'
    | '/c/ordertracking'
    | '/c/privacy-policy'
    | '/c/shop'
    | '/c/wishlist'
    | '/c'
    | '/c/product/$itemId'
  id:
    | '__root__'
    | '/'
    | '/c'
    | '/c/checkout'
    | '/c/orderplaced'
    | '/c/ordertracking'
    | '/c/privacy-policy'
    | '/c/shop'
    | '/c/wishlist'
    | '/c/'
    | '/c/product/$itemId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CRoute: typeof CRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/c': {
      id: '/c'
      path: '/c'
      fullPath: '/c'
      preLoaderRoute: typeof CRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/': {
      id: '/c/'
      path: '/'
      fullPath: '/c/'
      preLoaderRoute: typeof CIndexRouteImport
      parentRoute: typeof CRoute
    }
    '/c/wishlist': {
      id: '/c/wishlist'
      path: '/wishlist'
      fullPath: '/c/wishlist'
      preLoaderRoute: typeof CWishlistRouteImport
      parentRoute: typeof CRoute
    }
    '/c/shop': {
      id: '/c/shop'
      path: '/shop'
      fullPath: '/c/shop'
      preLoaderRoute: typeof CShopRouteImport
      parentRoute: typeof CRoute
    }
    '/c/privacy-policy': {
      id: '/c/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/c/privacy-policy'
      preLoaderRoute: typeof CPrivacyPolicyRouteImport
      parentRoute: typeof CRoute
    }
    '/c/ordertracking': {
      id: '/c/ordertracking'
      path: '/ordertracking'
      fullPath: '/c/ordertracking'
      preLoaderRoute: typeof COrdertrackingRouteImport
      parentRoute: typeof CRoute
    }
    '/c/orderplaced': {
      id: '/c/orderplaced'
      path: '/orderplaced'
      fullPath: '/c/orderplaced'
      preLoaderRoute: typeof COrderplacedRouteImport
      parentRoute: typeof CRoute
    }
    '/c/checkout': {
      id: '/c/checkout'
      path: '/checkout'
      fullPath: '/c/checkout'
      preLoaderRoute: typeof CCheckoutRouteImport
      parentRoute: typeof CRoute
    }
    '/c/product/$itemId': {
      id: '/c/product/$itemId'
      path: '/product/$itemId'
      fullPath: '/c/product/$itemId'
      preLoaderRoute: typeof CProductItemIdRouteImport
      parentRoute: typeof CRoute
    }
  }
}

interface CRouteChildren {
  CCheckoutRoute: typeof CCheckoutRoute
  COrderplacedRoute: typeof COrderplacedRoute
  COrdertrackingRoute: typeof COrdertrackingRoute
  CPrivacyPolicyRoute: typeof CPrivacyPolicyRoute
  CShopRoute: typeof CShopRoute
  CWishlistRoute: typeof CWishlistRoute
  CIndexRoute: typeof CIndexRoute
  CProductItemIdRoute: typeof CProductItemIdRoute
}

const CRouteChildren: CRouteChildren = {
  CCheckoutRoute: CCheckoutRoute,
  COrderplacedRoute: COrderplacedRoute,
  COrdertrackingRoute: COrdertrackingRoute,
  CPrivacyPolicyRoute: CPrivacyPolicyRoute,
  CShopRoute: CShopRoute,
  CWishlistRoute: CWishlistRoute,
  CIndexRoute: CIndexRoute,
  CProductItemIdRoute: CProductItemIdRoute,
}

const CRouteWithChildren = CRoute._addFileChildren(CRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CRoute: CRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
